import { SignOutButton } from '@/components/auth/sign-out-button';
import { DangerZone } from '@/components/settings/danger-zone';
// import { ExportSection } from '@/components/settings/export-section';
import { ProfileSection } from '@/components/settings/profile-section';
import { Separator } from '@iq/ui';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authed/settings')({
  component: SettingsRoute,
});

function SettingsRoute() {
  const { t } = useTranslation();
  return (
    <main data-testid="settings-route" className="mx-auto flex max-w-3xl flex-col gap-6 px-4 py-8">
      <header className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">{t('settings.title')}</h1>
        <SignOutButton variant="outline" />
      </header>
      <Separator />
      <ProfileSection />
      {/* <ExportSection /> — disabled per product request (GDPR export) */}
      <DangerZone />
    </main>
  );
}
